// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback } from "react";
import { useApolloClient } from "@apollo/client";
import { MONITORING_GET_DASHBOARD } from "@/queries/MonitoringGetDashboard";
import { MONITORING_LIST_DASHBOARDS } from "@/queries/MonitoringListDashboards";
import { EMonitoringCapability } from "@/components/monitoring/types";
import { useMonitoringEditor } from "./useMonitoringEditor";
import { useMonitoringEditorApi } from "./useMonitoringEditorApi";
/**
 * The editor as the Dashboard tab wires it in: its entry points for a
 * viewer who may configure, its dialogs, and a reload of the view whenever
 * a document is saved or the event reset.
 */
export var useMonitoringTabEditor = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, configure = _a.configure, api = _a.api;
    var client = useApolloClient();
    var harvest = useMonitoringEditorApi(electionEventId);
    var onChanged = useCallback(function () {
        void client
            .refetchQueries({ include: [MONITORING_GET_DASHBOARD, MONITORING_LIST_DASHBOARDS] })
            .catch(function () { return undefined; });
    }, [client]);
    var editor = useMonitoringEditor({
        api: api !== null && api !== void 0 ? api : harvest,
        view: { electionEventId: electionEventId, electionId: electionId },
        onChanged: onChanged,
    });
    var granted = configure === EMonitoringCapability.GRANTED;
    return { actions: granted ? editor.actions : undefined, element: granted ? editor.element : null };
};
